import React, { useEffect } from "react";
import { Box, Chip, Divider, Grid, List, ListItem, ListItemText, Stack, ThemeProvider, Typography, colors } from "@mui/material";
import { ArrowRight } from "@mui/icons-material";
import "./App.css";

import Intro from "../components/Intro/Intro";
import MyNavbar from "../components/MyNavbar/MyNavbar";
import MyFooter from "../components/MyFooter/MyFooter";

// static infos
import Me from "../static/intro";
import { theme as MyTheme } from "../config/theme";
import { experienceData } from "../static/experience";
import { getDuration } from "../util/date-util";
import useWindowWidth from "../util/window-width";

function App() {
  useEffect(() => {
    document.title = "Chun Yen Chang-Sundin";
  });

  const windowWidth = useWindowWidth();
  return (
    <div className="App">
      <MyNavbar />
      <main className="main-frame">
        <ThemeProvider theme={MyTheme}>
          <Grid container spacing={2} maxWidth={1320} mx={"auto"} mb={3}>
            <Grid size={{ md: 12, lg: 4 }} px={2}>
              <Intro {...Me} />
            </Grid>
            {windowWidth < 1320 && (
              <Grid size={12} px={2}>
                <hr />
              </Grid>
            )}
            <Grid size={{ md: 12, lg: 8 }} px={2}>
              <Typography variant="h5" mb={1} color={colors.grey[600]}>
                Experience
              </Typography>
              <Stack direction="column" spacing={2}>
                {experienceData.map((exp, index) => (
                  <Stack direction={"column"} spacing={1} key={`exp-${exp.title}`}>
                    {/* title, location, year */}
                    <div>
                      <Stack direction={"row"} justifyContent={"space-between"}>
                        <Typography variant="h6" color="primary.dark">
                          {exp.title}
                        </Typography>
                        <Typography color={colors.grey[500]} fontWeight={300}>
                          {exp.startDate.toLocaleString("default", { month: "short", year: "numeric" })}
                          &nbsp; - &nbsp;
                          {exp.endDate ? exp.endDate.toLocaleString("default", { month: "short", year: "numeric" }) : "present"}
                          &nbsp; ({getDuration(exp.startDate, exp.endDate)})
                        </Typography>
                      </Stack>
                      <div>
                        <Typography fontWeight={500} component={"span"} color={colors.grey[900]}>
                          {exp.employer}
                        </Typography>{" "}
                        @ {exp.location}
                      </div>
                    </div>
                    <>
                      {exp.description.summary && <div>{exp.description.summary}</div>}
                      {exp.description.bullets && (
                        <Stack direction={"column"} pl={1}>
                          <List>
                            {exp.description.bullets.map((item, bIndex) => (
                              <ListItem key={`exp-${exp.title}-bullet-${bIndex}`} disableGutters sx={{padding: 0}}>
                                <ArrowRight fontSize="small" />
                                <ListItemText primary={item} />
                              </ListItem>
                            ))}
                          </List>
                        </Stack>
                      )}
                    </>
                    {exp.extraProjects && (
                      <>
                        <Box>
                          <Chip label="Projects" size="small" sx={{letterSpacing: 1, padding: '0 5px'}}/>
                        </Box>
                        <Stack direction={"column"} spacing={1}>
                          {exp.extraProjects.map((proj, pIndex) => (
                            <Stack direction={"column"} pl={2} key={`exp-${exp.title}-proj-${proj.projectName}`}>
                              <Typography color={colors.grey[900]} fontWeight={500}>
                                {proj.projectName}
                              </Typography>
                              {proj.description.summary && <div>{proj.description.summary}</div>}
                              {proj.description.bullets && (
                                <List>
                                  {proj.description.bullets.map((item, pbIndex) => (
                                    <ListItem key={`exp-${exp.title}-proj-${proj.projectName}-bullet-${pbIndex}`} sx={{padding: 0}}>
                                      <ArrowRight fontSize="small" />
                                      <ListItemText primary={item} />
                                    </ListItem>
                                  ))}
                                </List>
                              )}
                            </Stack>
                          ))}
                        </Stack>
                      </>
                    )}
                    {index < experienceData.length - 1 && (<Divider variant="middle"/>)}
                  </Stack>
                ))}
              </Stack>
            </Grid>
          </Grid>
        </ThemeProvider>
      </main>

      <MyFooter />
    </div>
  );
}

export default App;
